// Do not overwrite this file when in different branches

import * as firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/analytics"
import "firebase/performance"
import 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const analytics = firebase.analytics()
const performance = firebase.performance()
const auth = firebase.auth()

const apiUrl = 'https://production.asmahhealthhub-api.com'

// Firestore on local development
if (location.hostname === "localhost") {
  db.settings({
    host: "localhost:8081",
    ssl: false
  })
}

export {
  firebase,
  db,
  analytics,
  performance,
  auth,
  apiUrl
}
